import { render, staticRenderFns } from "./vuex-toggle.vue?vue&type=template&id=60a49d9a"
import script from "./vuex-toggle.vue?vue&type=script&lang=js"
export * from "./vuex-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports